/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { Img_url } from '../Shared/constant';
// import Button from './Button';
const VimeoVideo = ({ faceVideo, isDelete, onDelete }) => {
  const iframeRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );

    if (iframeRef.current) {
      observer.observe(iframeRef.current);
    }

    return () => {
      if (iframeRef.current) {
        observer.unobserve(iframeRef?.current);
      }
    };
  }, []);
  

  const getUrl = useMemo(()=>{
    if(faceVideo){
      let vimeoMatch = faceVideo?.match?.(/(?:vimeo\.com\/(?:video\/)?|player\.vimeo\.com\/video\/)(\d+)/);
      let youtubeMatch = faceVideo?.match?.(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([\w-]{11})/);
      
      if (vimeoMatch) return { platform: "Vimeo", id: `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=0&muted=1` };
      if (youtubeMatch) return { platform: "YouTube", id: `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=0&showinfo=0&playsinline=1&controls=0&muted=1&origin=${window.location.origin}` };
    }
    return null;
  }, [faceVideo]);
//   if(!getUrl){
//     return null;
//   }
  return (
    <div ref={iframeRef} className="youtube_link">
      {/* {!isDelete && <Button icon={Img_url.close} className={"close-button"} padding={"2px"} iconSize={18} onClick={onDelete} radius={"rounded"} />} */}
      {isVisible && (
        <iframe
          className="youtube_link-1"
          src={getUrl?.id}
          width="640"
          height="360"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Vimeo Video"
        />
      )}
    </div>
  );
};

export default VimeoVideo;
